// extracted by mini-css-extract-plugin
module.exports = {"citationTypePickerSearch":"citation-type-picker-search_citationTypePickerSearch__dtt_V"};